import vsComponent from './vsCard'

export default Vue => {
  Vue.component(vsComponent.name, vsComponent)
}
